var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImdbLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 987.17 482.96",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333 0 0 -1.3333 0 482.96)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6980.6 3622.2h-6557.7c-233.28 0-422.97-189.84-422.97-423.12v-2776c0-233.28 189.69-423.05 422.97-423.05h6557.7c233.28 0 423.12 189.77 423.12 423.05v2776c0 233.28-189.84 423.12-423.12 423.12",
    fill: "#e6b91e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1066 2855.1v-2112.6h547.89v2112.6h-547.89",
    fill: "#010101",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2783.3 2855.1-126.95-987.19-77.89 536.57c-23.52 172.03-45 322.58-66.49 450.62h-710.7v-2112.6h480.23l2.11 1394.7 201.72-1394.7h342.03l192.5 1425.4 1.02-1425.4h479.14v2112.6h-716.72",
    fill: "#010101",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4357.2 2474.1c21.4-12.26 35.86-31.79 42.03-59.37 6.09-26.64 9.22-88.05 9.22-183.28v-818.13c0-141.4-9.22-227.42-27.74-259.22-18.36-31.71-66.48-47.03-145.39-47.03v1386.4c59.38 0 100.32-6.09 121.88-19.38zm-5.16-1731.6c131.1 0 229.38 7.191 295 21.488 64.38 14.293 119.77 38.903 163.75 75.782 44.06 35.941 75.86 86.011 93.2 149.53 18.44 63.439 28.68 190.39 28.68 379.84v741.41c0 199.69-8.21 333.83-19.46 402.42-12.26 67.58-42.97 130.08-92.18 185.32-48.13 55.39-119.77 95.31-212.97 119.76-93.21 24.61-246.8 37.03-512.03 37.03h-408.6v-2112.6h664.61",
    fill: "#010101",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5832.8 1254.5c0-101.41-5.15-166.88-15.39-193.52-10.23-26.64-54.29-39.84-88.12-39.84-32.66 0-54.3 12.18-65.47 38.75-10.24 25.62-16.41 85-16.41 178.2v558.12c0 96.33 5.08 155.71 14.38 180.32 10.23 23.51 31.72 35.78 63.43 35.78 33.75 0 78.75-14.38 90.16-41.02 11.25-27.58 17.42-86.01 17.42-175.08zm-713.83 1600.6v-2112.6h493.68l34.76 134.14c43.99-54.289 93.21-94.141 147.42-121.87 54.38-26.559 134.14-39.918 196.57-39.918 86.09 0 161.79 22.5 224.29 68.589 63.52 45 103.52 99.297 119.93 160.86 17.42 62.339 25.62 156.56 25.62 282.58v592.81c0 127.97-2.11 211.02-8.2 249.84-5.24 38.91-22.66 78.91-50.24 119.93-28.67 40.93-68.59 72.57-121.87 95.23-54.3 22.5-116.72 33.75-189.53 33.75-62.43 0-143.28-12.34-197.58-37.97-53.2-24.53-102.42-62.42-146.41-112.58v687.19h-528.44",
    fill: "#010101",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImdbLogo);
export default __webpack_public_path__ + "static/media/imdb_logo.364dfd899f34660eb362f3cb485877fc.svg";
export { ForwardRef as ReactComponent };